import(/* webpackMode: "eager" */ "/codebuild/output/src967172558/src/nextjs-grudder/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src967172558/src/nextjs-grudder/src/app/auth/login/login-form.tsx");
